<template lang="html">
    <vue100vh style="position: fixed; width: -webkit-fill-available;">
    <v-card flat>
      <v-container fluid class="pl-0 pr-0 pt-0 pb-0">
            <v-toolbar style="background-color: white !important;">
              <v-icon @click="toPage()" class="mr-3" style="color: black;">mdi-chevron-left</v-icon>
              <div class="text-overflow" style="font-size: 20px;">{{detail_project.project_name}}</div>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-flex class="mt-2 mb-0" v-if="member.length !== 0">
                  <template v-for="(item,index) in member">
                    <v-avatar size="35" v-if="index < 3 && width > 450" class="ml-2">
                      <img v-if="item.profilepicture" :src="item.profilepicture" class="object-fit-img">
                      <img v-else-if="item.type == 'user'" :src="`${publicPath}/assets/img/default_profile/man-white.png`" class="border-img object-fit-img">
                      <img v-else-if="item.type == 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" class="border-img object-fit-img">
                      <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" class="border-img object-fit-img">
                    </v-avatar>
                    <v-avatar size="35" v-else-if="index < 2 && width <= 450 && width > 350" class="ml-2">
                      <img v-if="item.profilepicture" :src="item.profilepicture" class="object-fit-img">
                      <img v-else-if="item.type == 'user'" :src="`${publicPath}/assets/img/default_profile/man-white.png`" class="border-img object-fit-img">
                      <img v-else-if="item.type == 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" class="border-img object-fit-img">
                      <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" class="border-img object-fit-img">
                    </v-avatar>
                    <v-avatar size="35" v-else-if="index < 1 && width <= 350" class="ml-2">
                      <img v-if="item.profilepicture" :src="item.profilepicture" class="object-fit-img">
                      <img v-else-if="item.type == 'user'" :src="`${publicPath}/assets/img/default_profile/man-white.png`" class="border-img object-fit-img">
                      <img v-else-if="item.type == 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" class="border-img object-fit-img">
                      <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" class="border-img object-fit-img">
                    </v-avatar>
                  </template>
                  <v-avatar class="ml-1" color="green" v-if="(member.length - 3) > 0 && width > 450" size="18px">
                    <span class="white--text">+{{member.length - 3}}</span>
                  </v-avatar>
                  <v-avatar class="ml-1" color="green" v-if="(member.length - 2) > 0 && width <= 450 && width > 350" size="18px">
                    <span class="white--text">+{{member.length - 2}}</span>
                  </v-avatar>
                  <v-avatar class="ml-1" color="green" v-if="(member.length - 1) > 0 && width <= 350" size="18px">
                    <span class="white--text">+{{member.length - 1}}</span>
                  </v-avatar>
                </v-flex>
                <v-flex class="mt-2 mb-0" v-else>
                  <v-avatar size="35">
                    <img v-if="image_profile" :src="image_profile" class="object-fit-img">
                    <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" class="border-img object-fit-img">
                  </v-avatar>
                </v-flex>
                <v-btn
                  icon
                  color="black"
                  v-if="detail_project.detail !== ''"
                  small
                  @click="dialogDetailProject = true"
                  class="ml-2"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-dialog v-model="dialogDetailProject" persistent max-width="400" style="overflow-x: hidden !important;">
              <v-card>
                <v-card-title class="font-size18">{{$t('Task.allTask.projectDetail')}}</v-card-title>
                  <v-divider></v-divider>
                <v-card-text style="word-break: break-all !important;">{{detail_project.detail}}</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn rounded color="primary darken-1" text @click.native="dialogDetailProject = false">{{$t('AnswerQuestion.ok')}}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
        <v-layout row wrap class="mt-2 ml-4 mr-4 layout-height" v-if="progress" justify-center align-center>
          <v-progress-circular size="80" :indeterminate="progress" color="primary"></v-progress-circular>
        </v-layout>
        <v-layout row wrap class="mt-2 layout-height" v-else>
          <v-btn
            absolute
            dark
            fab
            bottom
            right
            color="primary"
            small
            @click="open_create_task()"
          >
            <v-icon style="color: white !important;">mdi-plus</v-icon>
          </v-btn>
          <v-flex sm12 md12 xl12 lg12 class="scrolling-wrapper pt-2">
            <div v-for="(item, index) in detail_project.state">
              <v-layout column wrap class="ml-3">
                <v-flex sm4 md4 xl4 lg4>
                  <v-layout row wrap>
                    <h2 class="ml-3">{{item.name}}</h2>
                    <span class="ml-2 font-size-14 mt-2 color-numtask">
                      {{$t('Task.allTask.numTask',{count: item.member.length})}}
                    </span>
                  </v-layout>
                  <v-system-bar class="system-barTodo" v-if="item.name.includes('Todo') || item.name.includes('todo')"></v-system-bar>
                  <v-system-bar class="system-barDoing" v-else-if="item.name.includes('Doing') || item.name.includes('doing')"></v-system-bar>
                  <v-system-bar class="system-barDone" v-else-if="item.name.includes('Done') ||item.name.includes('done')"></v-system-bar>
                  <v-system-bar class="system-barEtc" v-else></v-system-bar>
                  <!-- <v-system-bar class="system-bar"></v-system-bar> -->
                </v-flex>
                <div class="color-card-task">
                  <v-container fluid style="min-height: 0;" grid-list-xs>
                    <v-flex xs12 v-for="(member,indexmem) in item.member" :key="indexmem">
                      <div :class="checkpriorityTask(member.priority)" @click="open_detail_task(member._id, detail_project.tokenroom)">
                        <p class="mb-0 font-title-task ml-2">{{member.title}}</p>
                        <v-layout row wrap justify-end class="mr-2 mt-2">
                          <v-icon color="#d8d8d8" class="ml-3" v-if="member.count_comment != '0' && member.count_comment != undefined">fas fa-comment-dots</v-icon>
                          <span class="ml-2 pt-1" v-if="member.count_comment != '0' && member.count_comment != undefined">{{member.count_comment}}</span>
                          <v-spacer></v-spacer>
                          <v-avatar size="30" v-for="(item,index) in member.assign" v-if="index < 3" style="margin-left: 2px!important;" :key="index">
                            <img v-if="item.path_pic" :src="item.path_pic" class="object-fit-img">
                            <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" class="border-img object-fit-img">
                          </v-avatar>
                          <span v-if="(member.assign.length - 3) > 0" class="mt-1 ml-2">+{{member.assign.length - 3}}</span>
                      </v-layout>
                      </div>
                    </v-flex>
                  </v-container>
                </div>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <CreateTask :dialogCreateTask="dialogCreateTask" @closeCreateTask="closeCreateTask" :projectid="projectid" @createdtask="createdtask"></CreateTask> 
      <DetailTask :dialogDetailTask="dialogDetailTask" @closeDetailTask="closeDetailTask" :taskid="taskid" @edittask="edittask" @deletetask="deletetask" @commenttask="commenttask" :roomid="roomid"></DetailTask>
    </v-card>
  </vue100vh>
  </template>
  
  <script>
  import { sync } from 'vuex-pathify'
  import { Decode, Momenttime } from '@/services'
  
  import CreateTask from '@/views/Web/Manage/task/created_task_dialog_mo'
  import DetailTask from '@/views/Web/Manage/task/detail_task_dialog_mo'
  
  import vue100vh from 'vue-100vh'
  
  var _ = require('lodash')
  export default {
    data: () => ({
      publicPath: process.env.VUE_APP_BASE_PATH,
      tokenuser: '',
      detail_project: {},
      projectid: '',
      progress: false,
      taskid: '',
      roomid: '',
      dialogDetailTask: false,
      dialogCreateTask: false,
      member: [],
      dialogDetailProject: false,
      image_profile: '',
      widthScreen: document.documentElement.clientWidth,
      width: document.documentElement.clientWidth,
      data_user: {},
    }),
    components: {
      CreateTask,
      DetailTask,
      vue100vh
    },
    created () {
      // var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
      // this.tokenuser = decoded['tokenuser']
      var user_profile = ''
        if (JSON.parse(this.$cookie.get('user-profile') == null)) {
        user_profile = JSON.parse(localStorage.getItem('user-profile'))
      } else {
        user_profile = JSON.parse(this.$cookie.get('user-profile'))
      }
      this.data_user = user_profile['account']['profile']
      this.tokenuser = this.data_user.tokenuser
      this.get_data_room()
      window.addEventListener('resize', this.getDimensions);
    },
    watch: {
      // windowWidth () {
      //   if (this.windowWidth > 960) {
      //     this.$router.push('/chat/homepage')
      //   }
      // },
      socketmessage (data) {
        // console.log(data)
        if (data.tokenuser !== this.tokenuser) {
          if (data.message == 'create_task') {
            this.get_task_by_id(data.task_id, data.state.state_id, 'create')
          }
        }
      },
      socket_deletetask (data) {
        // console.log(data)
        if (data.tokenuser !== this.tokenuser) {
          this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/get_project_by_id', {
            tokenuser: this.tokenuser,
            tokenroom: this.$route.params.roomid,
            project_id: this.projectid
          }).then((responsed) => {
            // console.log(responsed.data.data)
            if (responsed.data.status == 'success') {
              this.detail_project = responsed.data.data
            }
          })
        }
      },
      socket_edittask (data) {
        // console.log(data)
        if (data.tokenuser !== this.tokenuser) {
          this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/get_task_by_id', {
            tokenuser: this.tokenuser,
            task_id: data.task_id
          }).then((responsed) => {
            if (responsed.data.status == 'success') {
              // console.log(responsed.data.data)
              var new_state = responsed.data.data.state.id
              var old_index = ''
              var index_member = ''
              var index = ''
              old_index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == data.state_id.id })
              index_member = _.findIndex(this.detail_project.state[old_index].member, function(o) { return o._id == data.task_id })
              index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == new_state })
              this.detail_project.state[old_index].member.splice(index_member, 1)
              this.detail_project.state[index].member.unshift(responsed.data.data)
            }
          })
        }
      }
    },
    methods: {
      toPage () {
        this.$router.go(-1)
      },
      getDimensions() {
        this.width = document.documentElement.clientWidth;
      },
      get_data_room () {
        this.detail = {}
        this.progress = true
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/getroom', {
          tokenuser: this.tokenuser,
          tokenroom: this.$route.params.roomid
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.progress = false
            this.detail = response.data
            var member = []
            member = response.data.data_room
            this.member = _.filter(member, function(o) { return o.statemember == 'active' })
            this.get_project_by_id(this.$route.params.projectid)
          }
        })
      },
      get_project_by_id () {
        this.progress = true
        this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/get_project_by_id', {
          tokenuser: this.tokenuser,
          tokenroom: this.$route.params.roomid,
          project_id: this.$route.params.projectid
        }).then((responsed) => {
          // console.log(responsed.data.data)
          this.progress = false
          if (responsed.data.status == 'success') {
            this.projectid = this.$route.params.projectid
            this.detail_project = responsed.data.data
            this.image_profile = responsed.data.data.owner_info.path_pic
          }
        })
      },
      checkpriorityTask (priority) {
        if (priority == '1' || priority == '2' || priority == '3') {
          return 'card-task-pri' + priority
        } else {
          return 'card-task-pri3'
        }
      },
      open_detail_task (taskid, tokenroom) {
        // console.log(tokenroom)
        this.taskid = taskid
        this.roomid = tokenroom
        // console.log(this.StateId)
        this.dialogDetailTask = true
      },
      closeDetailTask(value) {
        this.dialogDetailTask = value
      },
      open_create_task () {
        this.dialogCreateTask = true
      },
      createdtask (value) {
        this.get_task_by_id(value.task_id, value.state_id, value.event)
      },
      closeCreateTask(value) {
        this.dialogCreateTask = value
      },
      edittask (data) {
        // console.log(data)
        this.get_task_by_id(data.task_id, data.state_id, data.event, data.old_state)
      },
      deletetask (data) {
        // console.log(data)
        var index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == data.state_id })
        var index_member = _.findIndex(this.detail_project.state[index].member, function(o) { return o._id == data.task_id })
        this.detail_project.state[index].member.splice(index_member, 1)
      },
      commenttask (data) {
        var index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == data.state_id })
        var index_member = _.findIndex(this.detail_project.state[index].member, function(o) { return o._id == data.task_id })
        this.detail_project.state[index].member[index_member].count_comment = data.count_comment
      },
      get_task_by_id (taskid, stateid, stateevent, oldstate) {
        this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/get_task_by_id', {
          tokenuser: this.tokenuser,
          task_id: taskid
        }).then((responsed) => {
          if (responsed.data.status == 'success') {
            // console.log(responsed.data.data)
            var old_index = ''
            var index_member = ''
            var index = ''
            if (stateevent == 'edit') {
              old_index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == oldstate })
              index_member = _.findIndex(this.detail_project.state[old_index].member, function(o) { return o._id == taskid })
              index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == stateid })
              this.detail_project.state[old_index].member.splice(index_member, 1)
              this.detail_project.state[index].member.unshift(responsed.data.data)
              // console.log(this.detail_project.state[index].member)
            } else if (stateevent == 'create') {
              index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == stateid })
              this.detail_project.state[index].member.unshift(responsed.data.data)
            }
          }
        })
      }
    }
  }
  </script>
  
  <style lang="css" scoped>
  .text-overflow {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }
  .font-title-task {
    font-size: 16px!important;
    font-weight: 500!important;
    padding-top: 12px!important;
  }
  .color-card-task {
    overflow-y: scroll !important;
    overflow-x: hidden !important;
    /* height: 60vh !important; */
    height: calc(100vh - 128px) !important;
    margin-top: 20px !important;
    border-radius: 6px !important;
    background-color: #f1f1f1 !important;
    width: 250px !important;
  }
  .system-bar {
    height: 4px !important;
    background-color: #e0e0e0 !important;
    border-radius: 10px !important;
    /* margin-left: 18px !important; */
  }
  .system-barTodo {
    background-color: #667684;
    border-radius: 10px !important;
    height: 4px !important;
    margin-top: 8px !important;
  }
  .system-barDoing {
    background-color: #33bcd4;
    border-radius: 10px !important;
    height: 4px !important;
    margin-top: 8px !important;
  }
  .system-barDone {
    background-color: #6bc94f;
    border-radius: 10px !important;
    height: 4px !important;
    margin-top: 8px !important;
  }
  .system-barEtc {
    background-color: #bcc0c7;
    border-radius: 10px !important;
    height: 4px !important;
    margin-top: 8px !important;
  }
  .font-size-16 {
    font-size: 16px !important;
  }
  .ml-50 {
    margin-left: 50px !important;
  }
  .span-clear-filter {
     color: #949494 !important;
     font-size: 16px !important;
  }
  .card-task-pri1 {
    background-color: white !important;
    color: black !important;
    border-radius: 10px !important;
    margin-top: 10px !important;
    /* margin-left: 12px !important;
    margin-right: 12px !important; */
    border-left: #b3493d 12px solid !important;
    box-shadow: 0 6px 14px 0 rgba(142, 142, 147, 0.4);
    height: 85px !important;
    cursor: pointer !important;
  }
  .card-task-pri2 {
    background-color: white !important;
    color: black !important;
    border-radius: 10px !important;
    margin-top: 10px !important;
    /* margin-left: 12px !important;
    margin-right: 12px !important; */
    border-left: #fcbe55 12px solid !important;
    box-shadow: 0 6px 14px 0 rgba(142, 142, 147, 0.4);
    height: 85px !important;
    cursor: pointer !important;
  }
  .card-task-pri3 {
    background-color: white !important;
    color: black !important;
    border-radius: 10px !important;
    margin-top: 10px !important;
    /* margin-left: 12px !important;
    margin-right: 12px !important; */
    border-left: #a0a1a3 12px solid !important;
    box-shadow: 0 6px 14px 0 rgba(142, 142, 147, 0.4);
    height: 85px !important;
    cursor: pointer !important;
  }
  .layout-height {
    height: calc(100vh - 95px) !important;
    overflow-y: scroll !important;
    overflow-x: hidden !important;
    /* overflow: hidden !important; */
  }
  .width-100 {
    width: 100% !important;
  }
  .color-numtask {
    color: rgb(170, 170, 170) !important;
  }
  .scrolling-wrapper {
    overflow-x: scroll !important;
    overflow-y: hidden !important;
    height: 87vh !important;
    max-width: 95% !important;
    display: -webkit-inline-box !important;
    margin-left: 20px !important;
    /* padding-top: 5vh !important; */
  }
  .object-fit-img {
    object-fit: cover;
    object-position: 50% 0;
  }
  .border-img {
    border-color: grey !important;
    border-style: solid !important;
    border-width: thin !important;
  }
  </style>
  